import React, { Component } from 'react'
import { Alert, Modal, Row } from 'antd'
import TransactionUploadForm from '../../../../../components/Finance/Statements/Transactions/TransactionsUpload/TransactionUploadForm'

class TransactionModal extends Component {
  render() {
    const {
      visibleTransactionUpload,
      onCancelTransactionUpload,
      onTransactionUpload,
      transactionUploadFormRef,
      uploadingCSV,
    } = this.props
    return (
      <Modal
        visible={visibleTransactionUpload}
        title={'Confirm Transaction'}
        onCancel={onCancelTransactionUpload}
        onOk={onTransactionUpload}
        okText={'Upload'}
        destroyOnClose={true}
        confirmLoading={uploadingCSV}
        width={1234}>
        <Row>
          <TransactionUploadForm ref={transactionUploadFormRef} {...this.props} />
        </Row>
        <Row>
          <Alert
            message="For now please make sure there's no duplicated records. This feature is being work on."
            type="warning"
            showIcon
          />
        </Row>
      </Modal>
    )
  }
}

TransactionModal.propTypes = {}
TransactionModal.defaultProps = {}

export default TransactionModal
